import { useFormField } from '../../../useFormField';
import type { StripControlledProperties } from '../../../types';
import { ButtonGroupField, type ButtonGroupFieldProps } from '../../base-fields/ButtonGroupField';

interface SingleButtonGroupFormFieldProps<T> extends Omit<StripControlledProperties<ButtonGroupFieldProps<T>>, 'onSelect' | 'isSelected'> {
	name: string;
	onChangePassThrough?: (selected: T) => void;
}

export function SingleButtonGroupFormField<T>(props: SingleButtonGroupFormFieldProps<T>) {
	const fieldProps = useFormField<T>(props);

	const onChange = async (value: T) => {
		await fieldProps.onChange(value);
		props.onChangePassThrough?.(value);
	};

	return <ButtonGroupField<T> {...props} {...fieldProps} onSelect={onChange} isSelected={(id: T) => fieldProps.value === id} />;
}
